import { cn } from "@/lib/cn";

/** A shape standing in for content that has not arrived. */
export function Skeleton({ className }: { className?: string }) {
  return (
    <div
      className={cn("animate-pulse rounded-sm bg-ink-100", className)}
      aria-hidden="true"
    />
  );
}

/** Placeholder rows sized to the data table, so loading does not shift layout. */
export function TableSkeleton({ rows = 6, columns = 5 }: { rows?: number; columns?: number }) {
  return (
    <div className="divide-y divide-line-faint" aria-hidden="true">
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <div key={rowIndex} className="flex items-center gap-4 px-5 py-3.5">
          {Array.from({ length: columns }).map((__, colIndex) => (
            <Skeleton
              key={colIndex}
              // Capped rather than fixed. At a fixed 160 and 96 a five-column
              // skeleton is 664px wide, so every admin list scrolled sideways
              // on a phone for as long as it was loading — and then stopped,
              // which is exactly the kind of fault nobody reports.
              className={cn("h-3.5 min-w-0 flex-1", colIndex === 0 ? "max-w-40" : "max-w-24")}
            />
          ))}
        </div>
      ))}
    </div>
  );
}
